// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__1Aa_s","text":"Card_text__ThQ89","header":"Card_header__2iPUy","counter":"Card_counter__3hIzU"};